import { Box, Modal } from '@mui/material';
import React, { memo } from "react";
import styled from "styled-components";
import { closeModal } from "utils/assets/images";
import { CloudFlarePreview } from "..";
import PreviewWithPlayer from '../cloudFlare/PreviewWithPlayer';

const style = {};



const VideoContainer = styled.div`
  width: 100%;
  margin-bottom: 0px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  // padding-top: 56.25%;
  padding-top: 53.25%;

  @media screen and (max-width: 900px) {
    padding-top: 52%;
  }
`;

const DefaultVideoPlayer = ({ openVideoModal, handleClose, video, from="", is_placement= false }) => {
  return (
    <Modal open={openVideoModal} onClose={handleClose} className={`${from === "slideWidget" ? "video-player-on-canvas" : ""} modelCntnt`}>
      <Box  sx={style} className="modelCntntIner modalVideoPlay">
        <div className="lernModalBg">
          <div className="modelDtl">
            <div
              style={{ zIndex: 70 }}
              className="closeModelInfo closeVideoModal"
              onClick={handleClose}
            >
              <img
                style={{ height: "30px" }}
                src={closeModal}
                onClick={handleClose}
              />
            </div>

            <VideoContainer>
            {is_placement ? <PreviewWithPlayer iframeUrl={video} is_placement={is_placement} /> : <CloudFlarePreview iframeUrl={video} is_placement={is_placement} />}
            </VideoContainer>
          </div>
        </div>  
      </Box>
    </Modal>
  );
};

export default memo(DefaultVideoPlayer);
